import { Parcel } from "../../../../front-office/model/parcel";
import { IScannedItemsList } from "./scanned-items-list";

export class ScannedParcelsList implements IScannedItemsList<"parcel", Parcel> {
    public readonly type = "parcel";
    private readonly _items: Parcel[];

    constructor(items: Parcel[]) {
        this._items = [...items];
    }

    public add(item: Parcel) {
        if (!this._items.find(x => x.parcelId === item.parcelId)) {
            return new ScannedParcelsList([...this._items, item]);
        }

        return this;
    }

    public remove(item: Parcel) {
        if (this._items.find(x => x.parcelId === item.parcelId)) {
            const list = new ScannedParcelsList(this._items.filter(x => x.parcelId !== item.parcelId));

            return list.items.length === 0 ? undefined : list;
        }

        return this;
    }

    get items(): Parcel[] {
        return this._items;
    }
}
